export default {
  title: 'Tabless',
  form: {
    tabless_id: {
      label: 'ID Tabless',
      placeholder: 'ID interno no sistema Tabless',
    },
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    error: 'Falha ao guardar as alterações',
    success: 'Alterações guardadas',
  },
  connected: {
    title: 'Tabless está ligado',
    description: 'Esta integração está configurada.',
  },
};
